import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import BarChart from 'components/BarChart/BarChart'
import CircleChart from 'components/CircleChart/CircleChart'
// import ExampleComponent from '../ExampleComponent'
import { GlobalVariables } from 'Globals/GlobalVariables'
// import { useWindowSize } from 'usehooks-ts'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const [height, setHeight] = useState(0)
  const [headerHeight, setHeaderHeight] = useState(0)
  const [initialHeight, setInitialHeight] = useState(0)

  useEffect(() => {
    const headerElement = document.querySelector('[class*=FullHeader_root]')

    let headerHeight = 0
    if (headerElement) {
      // check if header is sticky
      const headerStyle = window.getComputedStyle(headerElement)

      const isSticky =
        headerStyle.position === 'sticky' &&
        headerStyle.top !== '0px' &&
        headerStyle.top !== 'auto'

      if (isSticky) {
        headerHeight = headerElement.clientHeight
        setHeaderHeight(headerHeight)

        console.log('headerHeight', headerHeight)
      } else {
        setHeaderHeight(0)
      }
      // console.log('isSticky', isSticky)
    }

    setInitialHeight(window.innerHeight - headerHeight)
    // setup resize listener
    const handleResize = () => {
      setHeight(window.innerHeight - headerHeight)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <AppContainer $colorMode={colorMode}>
      <TextWidth>
        {
          properties?.chartTyp === 'bar' ? (
            <BarChart
              colorMode={colorMode}
              tenant={tenant}
              headerHeight={headerHeight}
            />
          ) : properties?.chartTyp === 'circle' ? (
            <CircleChart
              colorMode={colorMode}
              tenant={tenant}
              headerHeight={headerHeight}
            />
          ) : (
            <></>
          ) // returning an empty JSX element instead of null
        }
      </TextWidth>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  margin: 0 auto 3rem auto;
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  @media only screen and (max-width: 599px) {
    margin: 0 auto 5rem auto;
    font-size: 1.7rem;
    line-height: 2.8rem;
  }
    // Inhaltsverzeichnis
    a {
    cursor: pointer;
    color: inherit;
    text-decoration: none;
    padding: 0.2rem 0 0;
    background-image: linear-gradient(
      to right,
      var(--yellow-main) 0,
      var(--yellow-main) 100%
    );
    background-size: 100% 20%;
    background-position-y: 17px;
    background-repeat: repeat-x;
    background-position: bottom;
  }

  a.link:hover,
  a.link:link,
  a.link:active,
  a.link:visited {
    background-image: linear-gradient(90deg, #ffe462, #ffe462);
    background-repeat: repeat-x;
    background-position: bottom;
    background-size: 100% 20%;
    transition: all 0.1s ease-in-out;
    color: var(--text-color);
    background-origin: content-box;
  }
  a.link:hover {
    background-size: 100% 100%;
  }
`
export default MainComponent
